export const MEDICINE_NAME_PRESETS = [
  // Pain Relief & Fever
  "Paracetamol",
  "Crocin",
  "Dolo 650",
  "Calpol",
  "Ibuprofen",
  "Aspirin",
  "Diclofenac",
  "Aceclofenac",
  "Combiflam",
  "Brufen",
  "Voveran",
  "Zerodol",
  "Meftal Spas",
  "Drotin",
  "Buscopan",
  
  // Antibiotics
  "Amoxicillin",
  "Azithromycin",
  "Augmentin",
  "Cefixime",
  "Ciprofloxacin",
  "Levofloxacin",
  "Doxycycline",
  "Norfloxacin",
  "Ofloxacin",
  "Cephalexin",
  "Metronidazole",
  "Clindamycin",
  "Erythromycin",
  "Clarithromycin",
  "Ampicillin",
  
  // Gastric & Acidity
  "Pantoprazole",
  "Omeprazole",
  "Rabeprazole",
  "Esomeprazole",
  "Ranitidine",
  "Famotidine",
  "Sucralfate",
  "Antacid",
  "ENO",
  "Digene",
  "Gelusil",
  "Mucaine Gel",
  "Pan 40",
  "Pan D",
  "Pantocid DSR",
  
  // Diabetes
  "Metformin",
  "Glimepiride",
  "Gliclazide",
  "Sitagliptin",
  "Vildagliptin",
  "Janumet",
  "Galvus Met",
  "Glycomet",
  "Gluconorm",
  "Insulin",
  "Lantus",
  "Humalog",
  "NovoMix",
  "Mixtard",
  "Actrapid",
  
  // Blood Pressure & Heart
  "Amlodipine",
  "Telmisartan",
  "Losartan",
  "Ramipril",
  "Enalapril",
  "Atenolol",
  "Metoprolol",
  "Carvedilol",
  "Bisoprolol",
  "Propranolol",
  "Diltiazem",
  "Verapamil",
  "Nifedipine",
  "Hydrochlorothiazide",
  "Furosemide",
  
  // Cholesterol
  "Atorvastatin",
  "Rosuvastatin",
  "Simvastatin",
  "Fenofibrate",
  "Crestor",
  "Lipitor",
  "Ecosprin",
  "Clopidogrel",
  "Prasugrel",
  "Ticagrelor",
  
  // Allergy & Cold
  "Cetirizine",
  "Levocetirizine",
  "Fexofenadine",
  "Loratadine",
  "Desloratadine",
  "Montelukast",
  "Allegra",
  "Zyrtec",
  "Claritin",
  "Benadryl",
  "Avil",
  "Sinarest",
  "Coldact",
  "Cheston Cold",
  "Wikoryl",
  
  // Cough & Respiratory
  "Dextromethorphan",
  "Ambroxol",
  "Bromhexine",
  "Levosalbutamol",
  "Salbutamol",
  "Theophylline",
  "Budesonide",
  "Formoterol",
  "Salmeterol",
  "Tiotropium",
  "Ascoril",
  "Benadryl Cough Syrup",
  "Corex",
  "Grilinctus",
  "Alex Syrup",
  
  // Vitamins & Supplements
  "Vitamin D3",
  "Vitamin B12",
  "Vitamin C",
  "Vitamin E",
  "Vitamin A",
  "Folic Acid",
  "Iron",
  "Calcium",
  "Zinc",
  "Magnesium",
  "Omega 3",
  "Multivitamin",
  "Becosules",
  "Neurobion Forte",
  "Supradyn",
  "Shelcal",
  "Calcimax",
  "Zincovit",
  "Limcee",
  "Celin",
  
  // Thyroid
  "Levothyroxine",
  "Thyronorm",
  "Eltroxin",
  "Thyrox",
  "Carbimazole",
  "Methimazole",
  "Propylthiouracil",
  
  // Mental Health
  "Alprazolam",
  "Clonazepam",
  "Diazepam",
  "Lorazepam",
  "Escitalopram",
  "Sertraline",
  "Fluoxetine",
  "Paroxetine",
  "Venlafaxine",
  "Duloxetine",
  "Mirtazapine",
  "Olanzapine",
  "Risperidone",
  "Quetiapine",
  "Aripiprazole",
  
  // Women's Health
  "Mefenamic Acid",
  "Tranexamic Acid",
  "Primolut N",
  "Duphaston",
  "Progesterone",
  "Estrogen",
  "Clomiphene",
  "Letrozole",
  "Meprate",
  "Unwanted 72",
  "I-Pill",
  "Ovral L",
  
  // Skin & Dermatology
  "Betamethasone",
  "Hydrocortisone",
  "Mometasone",
  "Clobetasol",
  "Tretinoin",
  "Adapalene",
  "Clindamycin Gel",
  "Benzoyl Peroxide",
  "Salicylic Acid",
  "Ketoconazole",
  "Miconazole",
  "Clotrimazole",
  "Terbinafine",
  "Permethrin",
  "Calamine Lotion",
  
  // Eye & Ear Drops
  "Moxifloxacin Eye Drops",
  "Tobramycin Eye Drops",
  "Timolol Eye Drops",
  "Latanoprost",
  "Refresh Tears",
  "Systane",
  "Ciplox Eye Drops",
  "Otrivin",
  "Otogesic Ear Drops",
  "Candid Ear Drops",
  
  // Others Common
  "Betahistine",
  "Cinnarizine",
  "Domperidone",
  "Ondansetron",
  "Lactobacillus",
  "ORS",
  "Cremaffin",
  "Lactulose",
  "Isabgol",
  "Dulcolax"
];